export default "__VITE_ASSET__CQlFDYEj__"